import { render, staticRenderFns } from "./HorizonLanding.vue?vue&type=template&id=fa2ebd24"
import script from "./HorizonLanding.vue?vue&type=script&lang=js"
export * from "./HorizonLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports